import {EditOutlined} from "@ant-design/icons";
import {Button, Input, Tooltip} from "antd";
import {useState} from "react";
import {sanitizeStepNameInput} from "./Actions/utils/functions";

/**
 * Nome da etapa selecionada. `title` é o que aparece no fluxo (o nome próprio
 * ou, na falta dele, o nome padrão do tipo); `name` é só o nome próprio — é ele
 * que entra em edição, para que abrir e fechar o editor sem digitar nada não
 * transforme o nome padrão em nome próprio.
 */
export const EditTitleAction = ({title, name = "", onChange}) => {
    const [value, setValue] = useState(name)
    const [isEdit, setIsEdit] = useState(false)

    // Recarrega o valor ao abrir: mesmo com a key={actionStep} remontando o
    // componente ao trocar de etapa, o `name` pode mudar por fora (ex.: outra
    // edição salva) sem remontagem.
    const startEdit = () => {
        setValue(name);
        setIsEdit(true);
    }

    const handleChange = () => {
        setIsEdit(false);
        onChange(value)
    }
    if (isEdit) {
        return <Input type="text"
                      autoFocus
                      placeholder={title}
                      value={value}
                      maxLength={60}
                      onChange={(e) => setValue(sanitizeStepNameInput(e.target.value))}
                      onPressEnter={handleChange}
                      onBlur={handleChange}
                      allowClear={true}
        >
        </Input>
    }
    // Cabeçalho editável: o texto é o título do passo e o lápis só aparece no
    // hover (ver .ae-title em FlowEditor.css) — antes parecia um botão comum.
    return <Tooltip title={"Renomeie a etapa para usá-la por nome nas etapas seguintes"}>
        <Button className="ae-title" type="text" onClick={startEdit}>
            <span className="ae-title__text">{title}</span>
            <EditOutlined/>
        </Button>
    </Tooltip>
}
